
// videos section
(function () {
    document.addEventListener('DOMContentLoaded', function() {
        const videoSection = document.querySelector('.videos');
        if(videoSection) {
            const videos = videoSection.querySelectorAll('video');
            let isVisible = false; // Флаг видимости слайдера
            const videoPlay = () => {
                if (!isVisible) return; // Если слайдер не виден, не воспроизводим видео
                
                videoSection.querySelectorAll('video').forEach(video => {
                    video.pause();
                });

                videos.forEach(video => {
                    if (video) {
                        video.currentTime = 0.2;
                        video.play();
                    }
                });
                
            };

            // === Intersection Observer для управления autoplay и воспроизведением видео ===
            const observer = new IntersectionObserver(entries => {
                entries.forEach(entry => {
                    isVisible = entry.isIntersecting;

                    if (isVisible) {
                        videoPlay();
                    } else {
                        videos.forEach(video => {
                            video.pause();
                        });
                    }
                });
            }, { threshold: 0.5 });

            observer.observe(document.querySelector('.videos__container'));
        }
    })
})();
// videos section

// Hero slider
(function () {
    const heroEl = document.querySelector('.hero-slider');
    if (!heroEl) return;
    const time = +heroEl.dataset.time || 5000;

    var HERO_VIDEO_BREAK = 768;

    function setHeroVideoSources() {
        var isMobile = window.innerWidth <= HERO_VIDEO_BREAK;
        heroEl.querySelectorAll('.hero-slider__video_desktop').forEach(function (v) {
            if (!isMobile && v.dataset.src && !v.src) v.src = v.dataset.src;
        });
        heroEl.querySelectorAll('.hero-slider__video_mobile').forEach(function (v) {
            if (isMobile && v.dataset.src && !v.src) v.src = v.dataset.src;
        });
    }

    function heroSlider() {
        if (typeof Swiper === 'undefined') return;
        setHeroVideoSources();
        // Откладываем создание Swiper в следующий кадр, чтобы не блокировать компоновку в текущем
        requestAnimationFrame(function () {
            runHeroSwiper();
        });
    }

    function runHeroSwiper() {
        const swiperHero = new Swiper('.hero-slider', {
            spaceBetween: 30,
            virtualTranslate: true,
            effect: "fade",
            centeredSlides: true,
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            pagination: {
                el: ".hero-slider .swiper-pagination",
                clickable: true,
            },
            autoplay: {
                delay: time,
                disableOnInteraction: false,
            },
            on: {
                slideChange: function () {
                    toggleAutoplay(this);
                }
            }
        });

        function toggleAutoplay(swiper) {
            const activeSlide = swiper.slides[swiper.activeIndex];
            const desktopVideo = activeSlide.querySelector('.hero-slider__video_desktop');
            const mobileVideo = activeSlide.querySelector('.hero-slider__video_mobile');

            // Определяем текущее видео (проверяем, какое из них отображается)
            const video = window.innerWidth <= 768 ? mobileVideo : desktopVideo;
            if (video) {
                swiper.autoplay.stop();
                video.play();

                video.addEventListener('ended', () => {
                    swiper.autoplay.start();
                }, { once: true });
            } else {
                swiper.autoplay.start();
            }
        }

        toggleAutoplay(swiperHero);
    }

    function initHero() {
        window.ensureSwiperLoaded ? window.ensureSwiperLoaded(heroSlider) : heroSlider();
    }

    if (Shopify.designMode) {
        initHero();
        document.addEventListener('shopify:section:load', initHero);
    } else {
        document.addEventListener('DOMContentLoaded', initHero);
    }
})();
// Hero slider